import { Button } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import styles from './Menu.css';
import MenuIcon from './assets/Left_Icon.png';

interface IMenuProps {
  isOpen: boolean;
  buttonRef: React.RefObject<HTMLButtonElement>;
  handleMenuClick: () => void;
}

export const Menu: React.FC<IMenuProps> = ({ isOpen, buttonRef, handleMenuClick }) => {
  return (
    <div className={styles['container']} id="menu-button">
      <Button
        ref={buttonRef}
        onClick={handleMenuClick}
        size="M"
        theme="fill_secondary"
        beforeIcon={
          isOpen ? (
            <IconActionClose16 color="icon-main-default" />
          ) : (
            <img src={MenuIcon} alt="Меню" style={{ width: 16, height: 16 }} />
          )
        }
      >
        Меню
      </Button>
    </div>
  );
};
